/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Boxes Slider js
(function () {
	if (!window.Swiper) {
		console.warn("Swiper library not loaded");
		return;
	}

	const boxesSliders = document.querySelectorAll(".js-boxes-slider");
	boxesSliders.forEach((sliderInstance, index) => {
		const sliderId = `boxes-slider-${index}`;
		sliderInstance.classList.add(sliderId);

		const autoscroll = sliderInstance.dataset.autoscroll === "true";
		const autoscrollSpeed = sliderInstance.dataset.autoscrollSpeed || 3000;
		const direction = sliderInstance.dataset.direction || "right";

		const swiperOptions = {
			slidesPerView: "auto",
			spaceBetween: 20,
			preloadImages: false,
			centeredSlides: true,
			speed: 300,
			autoHeight: false,
			breakpoints: {
				768: {
					spaceBetween: 40,
				},
			},
		};

		if (autoscroll) {
			swiperOptions.loop = true;
			//swiperOptions.freeMode = true;
			swiperOptions.allowTouchMove = false;
			swiperOptions.autoplay = {
				delay: 0,
				disableOnInteraction: false,
				reverseDirection: direction === "right",
			};
			swiperOptions.speed = autoscrollSpeed;
		}
		new Swiper(`.${sliderId}`, swiperOptions);
	});
})();
